// Dedicated print path: opens an isolated document containing just the newsletter
// "sheet" (which already carries all styling as inline styles), applies the theme
// palette, and uses Paged.js to render real page numbers in the bottom margin —
// so the browser's own Headers & Footers can be switched off while numbering stays.

const VARS = `
:root{--desk:#0c0a07;--paper:#14110c;--paper2:#1b1710;--paper3:#221d14;--ink:#ece3d0;--ink2:#d8cfbd;--muted:#9a8c66;--faint:#6b5f42;--rule:#6b5f42;--rule2:#3a3324;--accent:#e0663f;--gold:#d98a3a;--logo-filter:invert(1);--wm-opacity:.05;--chip:#221d14;}
[data-theme="light"]{--desk:#e7e4dd;--paper:#f4efe3;--paper2:#efe7d3;--paper3:#eadfc8;--ink:#1a160f;--ink2:#3a3327;--muted:#6b5f49;--faint:#8f815f;--rule:#1a160f;--rule2:#cfc4a8;--accent:#8a2b22;--gold:#a8442a;--logo-filter:none;--wm-opacity:.06;--chip:#eadfc8;}
`;

const FONTS = `<link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@500;700;900&family=Zilla+Slab:wght@400;500;600;700&family=Spectral:ital,wght@0,400;0,500;0,600;1,400&family=IBM+Plex+Mono:wght@400;500;600&display=swap" rel="stylesheet">`;

const PAGED_URL = "https://cdn.jsdelivr.net/npm/pagedjs@0.4.3/dist/paged.polyfill.js";

export function printNewsletter(theme: "dark" | "light") {
  const page = document.querySelector(".vox-page");
  if (!page) {
    window.print();
    return;
  }
  const w = window.open("", "_blank", "noopener");
  if (!w) {
    // Popup blocked — fall back to a plain print of the current page.
    window.print();
    return;
  }

  // Page-number color: mid-muted that reads on both palettes without needing a var.
  const pageNumColor = theme === "dark" ? "#9a8c66" : "#6b5f49";

  const doc = `<!doctype html><html><head><meta charset="utf-8"><title>Vox Imperialis</title>${FONTS}
<style>
${VARS}
*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact;}
html,body{margin:0}
body{background:var(--paper);color:var(--ink);font-family:'Spectral',Georgia,serif}
a{color:var(--accent);text-decoration:none}
/* strip any editor chrome that may be embedded in the copied markup */
.vox-blockctl,.vox-palette,.miniadd,.pdel,.vox-cap:empty{display:none!important}
[contenteditable]{outline:none!important}
.vox-page{max-width:none!important;margin:0!important;border:0!important;background:var(--paper)}
.vox-block{break-inside:avoid}
h2,h3{break-after:avoid}
@page{
  margin:16mm;
  @bottom-center{content:counter(page);font:500 10px 'IBM Plex Mono',monospace;color:${pageNumColor};}
}
</style>
<script>
var __printed=false;
function __doPrint(){ if(__printed) return; __printed=true; window.onafterprint=function(){window.close()}; setTimeout(function(){ window.focus(); window.print(); }, 50); }
window.PagedConfig={auto:true,after:function(){ __doPrint(); }};
/* Fallback: if Paged.js fails to load/run, still print (without page numbers). */
setTimeout(function(){ __doPrint(); }, 6000);
<\/script>
<script src="${PAGED_URL}"><\/script>
</head><body data-theme="${theme}">${page.outerHTML}</body></html>`;

  w.document.open();
  w.document.write(doc);
  w.document.close();
}
